// extracted by mini-css-extract-plugin
module.exports = {"root":"📦WarningBubble__root--1FPAY","withArrow":"📦WarningBubble__withArrow--33kPU","left":"📦WarningBubble__left--8wg_m","right":"📦WarningBubble__right--UNpNS"};